import { Typography } from '@mui/material';
import { useL10n } from '@uplift/hooks';
import { AlertInline } from '@uplift/ui-v2';

export const EmptyEmergencyContact: React.VFC = () => {
  const l10n = useL10n();

  return (
    <AlertInline title={l10n.accountSettings.profile.noEmergencyContact} severity="error" alignIcon="center">
      <Typography variant="body1" color="textPrimary">{l10n.accountSettings.profile.whoShouldWeContact}</Typography>
    </AlertInline>
  );
};